import { render, staticRenderFns } from "./transportSummary.vue?vue&type=template&id=e949eb96&scoped=true&"
import script from "./transportSummary.vue?vue&type=script&lang=js&"
export * from "./transportSummary.vue?vue&type=script&lang=js&"
import style0 from "./transportSummary.vue?vue&type=style&index=0&id=e949eb96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e949eb96",
  null
  
)

export default component.exports